/** Group/chat system events — membership notices in timeline */

export type SystemEventKind =
  | "member_added"
  | "member_removed"
  | "role_changed"
  | "group_created"
  | "disappear_changed"
  | "fork_detected";

export interface SystemEventPayload {
  op: "system";
  kind: SystemEventKind;
  text: string;
  at: number;
}

export function encodeSystemEvent(kind: SystemEventKind, text: string): string {
  const payload: SystemEventPayload = { op: "system", kind, text, at: Date.now() };
  return JSON.stringify(payload);
}

export function decodeSystemEvent(body: string): SystemEventPayload | null {
  try {
    const raw = JSON.parse(body) as SystemEventPayload;
    if (raw?.op !== "system" || !raw.kind || !raw.text) return null;
    return raw;
  } catch {
    return null;
  }
}

export function isSystemEventBody(body: string): boolean {
  return decodeSystemEvent(body) !== null;
}
